import { css } from "@emotion/css";
import classNames from "classnames";
import { useAtom } from "jotai";
// import Link from "next/link";
import { Link } from "../../../../juntion";
// import { useRouter } from "next/router";
import { useRouter } from "../../../../juntion";
import { useRef, useState } from "react";
import { actionUIAtom, selectedPageAtom } from "../../../../db";
import { getPageURLFromAction, useAction } from "../../../../hooks";
import { decodeStyle, mobile, parseStyle, tablet } from "../../../../juntion";
import styles from "./styles/NavMenu.module.css";

// TODO: Style and responsive behaviour
function NavMenu({ id, db, gs, device }) {
	const { performAction, currentPage } = useAction();
	const [_, setActionUI] = useAtom(actionUIAtom);
	const router = useRouter();
	const query = router.query["id"];
	//--------------------------------------
	const navRef = useRef();
	const [navPos, setNavPos] = useState([0, 0]);

	const data = db[id];

	const ps = parseStyle(data, gs, data.cstate);

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	const menuHeight = input.menuHeight + "px";

	const styleMenuItem = decodeStyle(ps.styleGroup.menuItem, gs);
	const styleMenuItemHover = decodeStyle(ps.styleGroup.menuItem__hover, gs);
	const styleMenuItemSelected = decodeStyle(
		ps.styleGroup.menuItem__selected,
		gs
	);

	// const styleActiveMenuItem = decodeStyle(ps.styleGroup.activeMenuItem, gs);

	const styleSubmenu = decodeStyle(ps.styleGroup.submenu, gs);
	const styleSubmenuItem = decodeStyle(ps.styleGroup.submenuItem, gs);
	const styleSubmenuItemHover = decodeStyle(
		ps.styleGroup.submenuItem__hover,
		gs
	);

	const styleBurger = decodeStyle(ps.mobileGroup.burgerButton, gs);

	const checkSelected = (item) => {
		if (item.action?.type === "page") {
			// if (item.action.params?.id === query[1]) {
			if (item.action.params?.id === currentPage) {
				return true;
			}
			return false;
		}
		return false;
	};

	const navItems = input.navItems || input.items;

	const is_custom_domain = !router.asPath?.startsWith("/w/");

	// Always keep containing section z-index >3
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
			}}
		>
			{tablet(device) ? (
				<nav
					className={styles.navWrapper}
					style={{
						justifyContent: styleBurger.textAlign,
						height: menuHeight,
						// display: tablet(device) ? "block" : "none",
					}}
				>
					<span
						className={styles.burgerBtn}
						style={{
							...styleBurger,
							height: menuHeight,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
						onClick={() => {
							setActionUI({
								type: "drawer",
								params: {},
							});
						}}
					>
						<i
							// className="fas fa-bars"
							className={input.burgerIcon.value}
							style={{
								// fontSize: styleBurger.size,
								fontSize: styleBurger.fontSize,
							}}
						/>
					</span>
				</nav>
			) : (
				<nav
					ref={navRef}
					className={styles.navWrapper}
					style={{
						height: menuHeight,
						// justifyContent: "flex-end",
						justifyContent: input.alignItems || "flex-end",
						gap: 0,
					}}
					onMouseOver={(e) => {
						const rect = navRef.current.getBoundingClientRect();
						setNavPos([rect.x, rect.y + rect.height]);
					}}
				>
					{navItems.map((item, index) => {
						return (
							<NavLink
								key={index}
								data={item}
								performAction={performAction}
								query={query}
								styleMenuItem={styleMenuItem}
								styleMenuItemHover={styleMenuItemHover}
								styleActiveMenuItem={styleMenuItemSelected}
								isSelected={checkSelected(item)}
								hasChild={item.children?.length > 0}
								is_custom_domain={is_custom_domain}
							>
								{item.children && item.children.length > 0 && (
									<nav
										// className={styles.submenu}
										className={
											input.submenuOrientation === "v"
												? styles.submenu
												: styles.submenu_hori
										}
										style={{
											...styleSubmenu,
											...(input.submenuOrientation === "h"
												? {
													top: navPos[1],
													left: 0,
												}
												: {}),
											userSelect: "none",
										}}
										onClick={(e) => {
											e.stopPropagation();
										}}
									>
										{item.children.map((child) => {
											return (
												// eslint-disable-next-line react/jsx-key
												<a
													key={child.name}
													className={css({
														...styleSubmenuItem,
														whiteSpace: "nowrap",
														margin: 0,
														"&:hover": {
															...styleSubmenuItemHover,
														},
														cursor: "pointer",
													})}
													onClick={(e) => {
														e.stopPropagation();
														performAction(
															child.action
														);
													}}
												>
													{child.name}
												</a>
											);
										})}
									</nav>
								)}
							</NavLink>
						);
					})}
				</nav>
			)}
		</div>
	);
}

function NavLink({
	data,
	isSelected,
	performAction,
	query,
	styleMenuItem,
	styleMenuItemHover,
	styleActiveMenuItem,
	children,
	hasChild,
	is_custom_domain,
}) {
	const clsNm = classNames(
		styles.navItem,
		css({
			...styleMenuItem,
			...(isSelected ? styleActiveMenuItem : {}),
			height: "100%",
			"&:hover": {
				...styleMenuItemHover,
			},
		})
	);
	if (data.action.type === "page") {
		const link = getPageURLFromAction(query, data.action, is_custom_domain);
		if (hasChild) {
			return (
				<div className={styles.navItemWrapper}>
					<Link href={link} passHref legacyBehavior>
						<a
							className={clsNm}
							onClick={(e) => e.stopPropagation()}
						>
							{data.name}
						</a>
					</Link>
					{children}
				</div>
			);
		} else {
			return (
				<Link href={link} passHref legacyBehavior>
					<a className={clsNm} onClick={(e) => e.stopPropagation()}>
						{data.name}
					</a>
				</Link>
			);
		}
	}

	if (hasChild) {
		return (
			<div className={styles.navItemWrapper}>
				<a
					className={clsNm}
					onClick={(e) => {
						e.stopPropagation();
						performAction(data.action);
					}}
				>
					{data.name}
					{children}
				</a>
				{/* {children} */}
			</div>
		);
	}
	return (
		<a
			className={clsNm}
			onClick={(e) => {
				e.stopPropagation();
				performAction(data.action);
			}}
		>
			{data.name}
			{children}
		</a>
	);
}

export default NavMenu;
